<div class="app-loader" [hidden]="!loader">
  <i class="fa fa-spinner fa-spin"></i>
</div>
<div *ngIf="!loader" class="app-container">
  <travel-ui-header
    [displaySetting]="siteContext?.displaySetting"
  ></travel-ui-header>
  <main class="main-content">
    <router-outlet
      *ngIf="!loader"
      (activate)="onActivate($event)"
    ></router-outlet>
  </main>
  <travel-ui-footer
    [displaySetting]="siteContext?.displaySetting"
  ></travel-ui-footer>
  <div *ngIf="siteContext?.name == 'HostMyTrips'">
    <a
      [href]="'https://wa.me/' + siteContext?.displaySetting?.phone"
      target="_blank"
      class="whatsapp-chat-button"
    >
      <i class="fa fa-whatsapp"></i>
    </a>
  </div>
</div>
